import styled from '@emotion/styled';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import { grey } from '@mui/material/colors';

const OverlayContentWrapper = styled('div')(
  ({ theme }) => ({
    position: 'relative',
    width: '100%',
    color: 'white',
    display: 'flex',
    justifyContent: 'center',
    '.MuiSvgIcon-root': {
      width: 32,
      height: 32,
      color: 'rgba(255, 255, 255, 0.6)',
    },
    '.button-wrapper': {
      position: 'absolute',
      top: 44,
      left: 0,
      marginTop: 6,
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      transition: theme.transitions.create(['margin-top', 'opacity']),
      '.MuiButton-root': {
        color: 'rgba(255, 255, 255, 0.7)',
        border: '2px solid rgba(255, 255, 255, 0.2)',
        ':hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
        },
      },
    },
  }),
  addHighContrastStyles(({ theme }) => ({
    '.MuiSvgIcon-root': {
      padding: 8,
      color: 'white',
      backgroundColor: 'black',
      borderRadius: 4,
    },
    '.button-wrapper': {
      top: 60,
      '.MuiButton-root': {
        color: 'white',
        backgroundColor: 'black',
        border: '2px solid white',
        transition: theme.transitions.create([
          'color',
          'background-color',
          'border-color',
        ]),
        ':hover, :focus': {
          color: 'black',
          backgroundColor: grey[400],
          borderColor: 'black',
        },
      },
    },
  })),
);

export default OverlayContentWrapper;
